import { render, staticRenderFns } from "./CategoriaManage.vue?vue&type=template&id=7f922d04&scoped=true"
import script from "./CategoriaManage.vue?vue&type=script&lang=js"
export * from "./CategoriaManage.vue?vue&type=script&lang=js"
import style0 from "./CategoriaManage.vue?vue&type=style&index=0&id=7f922d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f922d04",
  null
  
)

export default component.exports